<template>
    <div>

<v-toolbar
  dense
  tabs
  color="primary darken-2"
  dark
  class="page_title"
>
  <v-toolbar-title class="pa-0 pr-0 mt-1">
      <v-layout row >
          <v-flex xs10 sm11 text-xs-left>
              <a href="javascript: history.go(-1)" class="pa-0">
                  <v-btn flat fab small class="pa-0">
                      <i class="fas fa-arrow-left headline"></i>
                  </v-btn>
              </a>
              Affiliate maketing tutoriel 
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
              <router-link :to="$store.state.close_url2" class="pa-0 text-xs-right">
                  <v-btn flat fab small class="pa-0">
                      <i class="fas fa-close headline"></i>
                  </v-btn>
              </router-link>
          </v-flex>
      </v-layout>
  </v-toolbar-title>
</v-toolbar>

  <div class="video-manager">
    <div class="filter-controls">
      <v-select
        v-model="selectedSection"
        :items="availableSections"
        label="Filtrer par section"
        clearable
        outlined
        class="section-filter"
      ></v-select>
    </div>

    <div v-if="loading" class="loading-state">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </div>

    <div v-else class="video-grid">
      <div 
        v-for="video in filteredVideos"
        :key="video.id"
        class="video-card"
        :class="[selectedSection ? 'filtered' : '']"
      >
        <div class="video-wrapper">
          <video 
            controls 
            :poster="video.thumbnail_url"
            class="video-player"
          >
            <source :src="video.video_url" type="video/mp4">
          </video>
        </div>
        
        <div class="video-details">
          <h3 class="title">{{ video.title }}</h3>
          <div class="meta-section">
            <span class="section-tag">{{ video.marketing_section }}</span>
            <div class="video-stats">
              <span class="size">{{ video.formatted_size }}</span>
              <span class="views">{{ video.views_count }} vues</span>
            </div>
          </div>
          <p class="description">{{ video.description }}</p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      allVideos: [],
      selectedSection: null,
      loading: true,
      error: null
    }
  },

  computed: {
    availableSections() {
      return [...new Set(this.allVideos.map(v => v.marketing_section).filter(Boolean))]
    },

    filteredVideos() {
      if (!this.selectedSection) return this.allVideos
      return this.allVideos.filter(v => 
        v.marketing_section === this.selectedSection
      )
    }
  },

  async mounted() {
    try {
      const response = await axios.get('/api/v1/home/videos/')
      this.allVideos = response.data.results
    } catch (error) {
      this.error = error.response?.data || 'Erreur de chargement'
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.video-manager {
  max-width: 1280px;
  margin: 2rem auto;
  padding: 0 1rem;
}

.filter-controls {
  margin-bottom: 2rem;
  max-width: 300px;
}

.loading-state {
  display: flex;
  justify-content: center;
  padding: 4rem;
}

.video-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.video-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
}

.video-card:hover {
  transform: translateY(-3px);
}

.video-wrapper {
  position: relative;
  padding-top: 56.25%; /* 16:9 aspect ratio */
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-details {
  padding: 1rem;
}

.title {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.meta-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.section-tag {
  background: #e3f2fd;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.85rem;
}

.video-stats {
  display: flex;
  gap: 1rem;
  font-size: 0.8rem;
  color: #7f8c8d;
}

.description {
  font-size: 0.9rem;
  color: #34495e;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .video-grid {
    grid-template-columns: 1fr;
  }
  
  .video-card {
    margin-bottom: 1rem;
  }
}
</style>